import React from "react";
import { Paper } from "@mui/material";

const SectionCard = ({ children, className, sx, ...props }) => {
  return (
    <Paper
      className={className}
      elevation={0}
      sx={{
        p: 2,
        border: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default SectionCard;
